const SelectSensor = ({ Sensors, selectedSensor, setSelectedSensor }) => {
    return (
        <select
        id='sensor-select'
        className='choice-select'
        value={selectedSensor}
        onChange={(e) => setSelectedSensor(e.target.value)}
        >
            {selectedSensor === '' ? <option value="">
                ------
            </option> : null}
            {Sensors.map((sensor) => (
                <option
                    key={sensor.id}
                    value={sensor.id}
                >
                    {sensor.type} {sensor.dimension} {sensor.serial_number}
                </option>
            ))}
        </select>
    );
};

export default SelectSensor;